import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useApi } from "../../../../../context/api.js";
import MDButton from "../../../../../components/MDButton";
import MDTypography from "../../../../../components/MDTypography";
import { useHomework, setActivity } from "../../../../../context/homework";
import activities from "../../../../../components/activities";

function ActivityValidation({ m, title, onCancel, activityType, ...activityParams }) {
  const [_, dispatch] = useHomework();
  const navigate = useNavigate();

  const activity = activityType && activities[activityType];
  const ActivityIcon = activity && activity.icon;

  const handleStartActivity = () => {
    onCancel();
    setActivity(dispatch, {
      ...activityParams,
      activityType,
      milestoneId: m.id,
    });
    navigate("/activity", { replace: true });
  };

  return (
    <>
      <DialogContent>
        {title}
        <MDTypography
          variant="h6"
          component="div"
          mt={2}
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
        >
          {ActivityIcon && <ActivityIcon sx={{ height: 24, width: 24 }} />}{" "}
          {activity && activity.title}
        </MDTypography>
        {activity && activity.description && activity.description(activityParams)}
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onCancel}>Annuler</MDButton>
        <MDButton
          variant="contained"
          color="success"
          disabled={!activity}
          onClick={handleStartActivity}
        >
          Lancer l&apos;activité !
        </MDButton>
      </DialogActions>
    </>
  );
}

ActivityValidation.propTypes = {
  m: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.element,
  activityType: PropTypes.string,
};

export default ActivityValidation;
